export default __webpack_public_path__ + "static/IN-90X_10-1f86122eb682a1bd350723d442ad1707.webp";